var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import RuleSetDomainService from "../Domain/RuleSet/RuleSet.service";
const BASE_URL = "/aviso/ruleSet";
export default class RuleSetService {
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                ids: search.ids,
                names: search.names,
                active: search.active,
                query: search.query,
                modifiedByIds: search.modifiedByIds,
                modifiedDateFrom: search.modifiedDateFrom,
                createdDateTo: search.createdDateTo,
                createdDateFrom: search.createdDateFrom,
                searchText: search.searchText,
                orderBy: search.orderBy,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
            });
            return Object.assign(Object.assign({}, resp), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: resp.data.map(RuleSetDomainService.fromJSON) });
        });
    }
    static create(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/create", request).then(RuleSetDomainService.fromJSON);
        });
    }
    static update(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/update", request).then(RuleSetDomainService.fromJSON);
        });
    }
    static ruleSetCount() {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield RuleSetService.search({}, { max: 1 });
            return resp.total;
        });
    }
    static get(ruleSetId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                id: ruleSetId,
            }).then(RuleSetDomainService.fromJSON);
        });
    }
}
